const ARABIC_INDIC = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩']

/**
 * Render Latin digits as Arabic-Indic for display in Arabic.
 *
 * Phone numbers are stored once, in Latin, in contactInfo.ts — they are machine
 * values and must never be duplicated into locale JSON, which is how ar/contact
 * ended up holding "+٢٠ ١١١ ٨٣٢ ١٩٩٩" as a separate string that could drift from
 * the tel: href beside it. Transforming at render time keeps one source of truth
 * while still reading correctly in Arabic.
 *
 * Display only. Never apply this to a tel:/wa.me href — those must stay Latin.
 */
export const localizeDigits = (value: string, language: string): string =>
  language === 'ar' ? value.replace(/[0-9]/g, (d) => ARABIC_INDIC[Number(d)]) : value
